export enum MediaBreakpoint {
  xs = 576,
  md = 768,
  lg = 992,
  xl = 1200,
  xxl = 1600
}

export const mediaBreakpointDown = (bp: {
  breakpoint: 'xs' | 'md' | 'lg' | 'xl' | 'xxl'
  content: string
}) => {
  return `@media (max-width: ${MediaBreakpoint[bp.breakpoint]}px) {${
    bp.content
  }};`
}

export const mediaBreakpointUp = (bp: {
  breakpoint: 'xs' | 'md' | 'lg' | 'xl' | 'xxl'
  content: string
}) => {
  return `@media (min-width: ${MediaBreakpoint[bp.breakpoint]}px) {${
    bp.content
  }};`
}

export const mediaBreakpointBetween = (bp: {
  breakpointDown: 'xs' | 'md' | 'lg' | 'xl' | 'xxl'
  breakpointUp: 'xs' | 'md' | 'lg' | 'xl' | 'xxl'
  content: string
}) => {
  return `@media (min-width: ${
    MediaBreakpoint[bp.breakpointDown]
  }px) and (max-width: ${MediaBreakpoint[bp.breakpointUp]}px) {${bp.content}};`
}
